import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import COLORS from '@styles/theme/colors';

export const ModalTitle = styled('h3')({
  backgroundColor: '#FCFDFD',
  padding: '6px 25px',
  fontWeight: 600,
  fontSize: 18,
  borderRadius: '14px 14px 0 0',
  margin: '5px 0 0',
  borderBottom: '0.6px solid #D5D5D5'
});

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: 8,
  right: 8,
  color: COLORS.textSecondColor,
  border: 'none',
  background: 'transparent'
});

export const StyledActions = styled('div')({
  marginTop: 10,
  padding: '5px 25px 15px',
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  '& button:not(:first-of-type)': {
    marginLeft: 25
  },
  '& button': {
    padding: '8px 0'
  }
});

export const Content = styled('div')({
  padding: '10px 25px 0',
  maxHeight: '80vh',
  minHeight: '360px',
  overflowY: 'scroll',

  '&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb, &::-webkit-scrollbar': {
    width: 3,
    height: 3,
    background: '#fff',
    borderRadius: 10,
    cursor: 'pointer'
  },

  '&::-webkit-scrollbar-thumb': {
    background: '#4F77DE'
  }
});
